import { render, staticRenderFns } from "./HotlistForm.vue?vue&type=template&id=553a6342&scoped=true&"
import script from "./HotlistForm.vue?vue&type=script&lang=js&"
export * from "./HotlistForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a6342",
  null
  
)

export default component.exports